import React, { useEffect } from "react";
import { Link, useNavigate } from "react-router-dom";
import MobileBottomBar from "../Layout/MobileBottomBar";


function ShippingPolicy() {
  const navigate = useNavigate();
  


  return (
    <>
      <section className="modern-page-banner">
        <div className="container">
          <div className="banner-content">
            <div className="banner-icon">
              <i className="fas fa-shipping-fast"></i>
            </div>
            <h1 className="banner-title">Shipping & Delivery Policy</h1>
            <p className="banner-subtitle">Fast, safe, and convenient food delivery</p>
          </div>
        </div>
      </section>

      <section className="modern-content-section">
        <div className="container">
          <div className="content-wrapper">
            <div className="intro-section">
              <div className="intro-card">
                <p className="intro-text">
                  At Fynito, we are committed to ensuring that your orders reach you quickly, safely, and conveniently. 
                  This Shipping & Delivery Policy explains how we process and deliver your food orders.
                </p>
              </div>
            </div>

            <div className="policy-section">
              <div className="policy-card">
                <div className="section-header">
                  <div className="section-icon">
                    <i className="fas fa-map-marker-alt"></i>
                  </div>
                  <h5 className="section-title">Service Availability</h5>
                </div>
                <ul className="modern-content-list">
                  <li>
                    Fynito currently operates in selected areas of Andhra Pradesh (including Amaravathi and nearby locations).
                  </li>
                  <li>
                    Delivery availability depends on your pin code/location and the restaurant partner's service radius.
                  </li>
                </ul>
              </div>

              <div className="policy-card">
                <div className="section-header">
                  <div className="section-icon">
                    <i className="fas fa-clock"></i>
                  </div>
                  <h5 className="section-title">Delivery Timelines</h5>
                </div>
                <ul className="modern-content-list">
                  <li>
                    Delivery times are estimated based on restaurant preparation time, distance, and traffic conditions.
                  </li>
                  <li>
                    Standard delivery usually takes 30–60 minutes from the time of order confirmation.
                  </li>
                  <li>
                    During peak hours, festivals, or unexpected circumstances (e.g., bad weather, traffic jams), delivery may take longer.
                  </li>
                </ul>
              </div>

              <div className="policy-card">
                <div className="section-header">
                  <div className="section-icon">
                    <i className="fas fa-credit-card"></i>
                  </div>
                  <h5 className="section-title">Delivery Charges</h5>
                </div>
                <ul className="modern-content-list">
                  <li>
                    Delivery charges, if applicable, are shown at checkout before payment.
                  </li>
                  <li>
                    Charges may vary depending on distance, restaurant policies, or promotions.
                  </li>
                  <li>
                    Occasionally, we run free delivery offers for specific restaurants or order values.
                  </li>
                </ul>
              </div>

              <div className="policy-card">
                <div className="section-header">
                  <div className="section-icon">
                    <i className="fas fa-search-location"></i>
                  </div>
                  <h5 className="section-title">Order Tracking</h5>
                </div>
                <ul className="modern-content-list">
                  <li>
                    Once an order is placed, you can track it live in the Fynito app.
                  </li>
                  <li>
                    You will also receive updates via SMS/Email/Push notifications regarding order confirmation, preparation, pickup, and delivery.
                  </li>
                </ul>
              </div>

              <div className="policy-card">
                <div className="section-header">
                  <div className="section-icon">
                    <i className="fas fa-user-tie"></i>
                  </div>
                  <h5 className="section-title">Delivery Partner Guidelines</h5>
                </div>
                <ul className="modern-content-list">
                  <li>
                    Our delivery partners are trained to handle your food with care and deliver promptly.
                  </li>
                  <li>
                    For your safety and convenience, you can contact your delivery partner directly through the app.
                  </li>
                </ul>
              </div>

              <div className="policy-card">
                <div className="section-header">
                  <div className="section-icon">
                    <i className="fas fa-exclamation-triangle"></i>
                  </div>
                  <h5 className="section-title">Delayed or Failed Deliveries</h5>
                </div>
                <ul className="modern-content-list">
                  <li>
                    If delivery is delayed beyond the expected time, our support team will notify you and assist with updates.
                  </li>
                  <li>
                    In case a delivery cannot be completed due to:
                  </li>
                </ul>
                <div style={{ marginLeft: '20px', marginTop: '15px' }}>
                  <ul className="modern-content-list">
                    <li>Incorrect address/contact details</li>
                    <li>Customer unavailability</li>
                    <li>Restaurant cancellation</li>
                  </ul>
                </div>
                <p style={{ marginTop: '15px', color: '#4a5568', fontSize: '15px' }}>
                  Fynito reserves the right to cancel the order and apply relevant cancellation/refund policies.
                </p>
              </div>

              <div className="policy-card">
                <div className="section-header">
                  <div className="section-icon">
                    <i className="fas fa-undo"></i>
                  </div>
                  <h5 className="section-title">Refunds & Cancellations</h5>
                </div>
                <ul className="modern-content-list">
                  <li>
                    Refunds related to delayed, cancelled, or undelivered orders will follow our Refund & Cancellation Policy.
                  </li>
                  <li>
                    Any disputes regarding delivery must be reported within 24 hours of order placement.
                  </li>
                </ul>
              </div>

              <div className="policy-card highlight-card">
                <div className="section-header">
                  <div className="section-icon info">
                    <i className="fas fa-headset"></i>
                  </div>
                  <h5 className="section-title">Customer Support</h5>
                </div>
                <p className="deletion-intro">
                  For any queries related to delivery, please contact our Fynito Support Team:
                </p>
                
                <div className="contact-info">
                  <div style={{ display: 'flex', flexDirection: 'column', gap: '15px', alignItems: 'center' }}>
                    <Link to="mailto:support@fynito.com" className="contact-email">
                      <i className="fas fa-envelope"></i>
                      support@fynito.com
                    </Link>
                    <Link to="tel:+917036363457" className="contact-email" style={{ background: 'linear-gradient(135deg, #28a745 0%, #20c997 100%)' }}>
                      <i className="fas fa-phone"></i>
                      +91-7036363457
                    </Link>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </section>

      {/* Mobile Bottom Bar */}
      <MobileBottomBar />
    </>
  );
}

export default ShippingPolicy; 